module.exports = new __parcel__URL__("stormwave.add597ff.png").toString();